export const INFO_MAX_LENGTH = 30;
export const HEADER_MAX_LENGTH = 72;
